import styled from 'styled-components';

const BackButton = styled.div`
    margin-top: -15px;
    margin-bottom: 30px;
`;

export default BackButton;
